<template>
  <div class="item">
    <router-link
      :to="{ name: 'chapters.show', params: { bookSlug: chapter.book.slug, slug: chapter.content.slug } }"
      class="d-block"
    >
      <div
        class="d-flex align-items-center chapter-item link-color1 rounded-regular"
        :class="{
          owned: owned
        }"
      >
        <div
          class="reorder mr-3"
          v-if="owned"
        >
          <i class="fa fa-reorder"></i>
        </div>
        <div
          class="image rounded-regular background-cover shadow-light mr-2"
          :style="{ backgroundImage: `url('${chapter.content.cover}')` }"
        ></div>
        <div class="content pl-2 d-flex align-items-center">
          <span class="font-weight-bold font-size-regular">
            {{ orderNumber + 1 }}. {{ chapter.content.title }}
            <template v-if="chapter.content.status === 'scheduled'">
              (agendado)
            </template>
            <template v-else-if="chapter.content.status === 'draft'">
              (rascunho)
            </template>
            <BaseIcon
              v-if="(owned && chapter.content.visibility === 'private') || (!canUserReadBook && !chapter.is_sample)"
            >
              <LockIcon />
            </BaseIcon>
          </span>
        </div>
        <div class="content pl-2 d-flex align-items-right" v-if="chapter && chapter.content.progress > 0">
          <span class="font-weight-bold font-size-regular">
            <CircleProgress :percentage="chapter.content.progress"/>
          </span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>

import { mapState } from 'vuex'

import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import LockIcon from '@/components/common/Icon/LockIcon.vue'
import CircleProgress from '@/components/common/Progress/CircleProgress.vue'

export default {
  name: 'ChapterListItem',
  props: ['chapter', 'orderNumber', 'canUserReadBook'],
  components: {
    BaseIcon,
    LockIcon,
    CircleProgress
  },
  computed: {
    owned () {
      return this.user && this.user.id === this.chapter.user.id
    },
    ...mapState('users', {
      user: state => state.user
    })
  }
}
</script>

<style lang="scss" scoped>
.chapter-item {

  .image {
    width: 60px;
    height: 40px;
    flex-shrink: 0;
  }
  .content {
    flex-grow: 1;
  }

  .reorder {
    color: rgba(0,0,0,0.2);
    flex-shrink: 0;
  }

  &.owned {
    &:hover {
      cursor: grab;
      background: rgba(93, 93, 93, 0.05);
    }
  }
}

</style>
